import Button from './commons/buttons';
import Download from './commons/download';
import HeaderReveal from './commons/headerReveal';
import MainMenu from './commons/nav';
import PatternReveal from './commons/patternReveal';
import ScrollReveal from './commons/scrollReveal';

window.fkCommons = [];
window.revealedSections = [];
const commonClasses = {
  Download,
  Button,
  MainMenu,
  HeaderReveal,
  PatternReveal,
};

export const initCommonModules = () => {
  const $sections = document.querySelectorAll('[animate-up]');
  $sections.forEach(($section) => {
    const scrollReveal = new ScrollReveal($section);
    commonClasses.ScrollReveal = scrollReveal;
    window.revealedSections.push(scrollReveal);
  });

  const $moduleElements = document.querySelectorAll('[data-common]');
  $moduleElements.forEach(($element) => {
    const id = $element.getAttribute('data-common');
    const CommonClass = commonClasses[id];
    if (!CommonClass) return;

    const common = new CommonClass($element);
    window.fkCommons.push(common);
  });
};
